var baseUrl = 'https://webm.ceecexpo.com/pcApi'
//var baseUrl = 'http://127.0.0.1:8787/pcApi'
//var baseUrl = 'https://testh.ceecexpo.com/pcApi'
export {
    baseUrl
}